import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MoneyTypeEnum } from 'src/enums';
import { AuthService } from '../login/auth.service';
import { Socket } from 'ngx-socket-io';
import {
  Fiscal,
  FiscalSessionChange,
  FiscalSearchDto,
  FiscalAddMoneyDto,
  FiscalCollectDto,
  FiscalCreateDto,
  FiscalUpdateDto,
  ProductInDoc
} from 'src/typings';

@Injectable({
  providedIn: 'root'
})
export class FiscalService {
  sessionChanges = this.socket.fromEvent<FiscalSessionChange | string>('sessionChanges');

  constructor(private http: HttpClient, private authService: AuthService, private socket: Socket) {}

  search(payload?: FiscalSearchDto) {
    return this.http.post<{
      data: Fiscal[];
      length: number;
    }>(
      `
    ${environment.BACKEND}/fiscal/search`,
      payload
    );
  }

  getOne(id: number) {
    return this.http.get<Fiscal>(`${environment.BACKEND}/fiscal/${id}`);
  }

  create(payload: FiscalCreateDto) {
    return this.http.post<Fiscal>(`${environment.BACKEND}/fiscal/create`, payload);
  }

  update(payload: FiscalUpdateDto) {
    return this.http.put<Fiscal>(`${environment.BACKEND}/fiscal/update`, payload);
  }

  delete(id: number) {
    return this.http.delete<void>(`${environment.BACKEND}/fiscal/${id}`);
  }

  openSession(id?: number) {
    return this.http.put<unknown>(`${environment.BACKEND}/fiscal/session/open`, { id });
  }

  closeSession(id?: number) {
    return this.http.put<unknown>(`${environment.BACKEND}/fiscal/session/close`, { id });
  }

  xReport(id: number) {
    return this.http.get<any>(`${environment.BACKEND}/fiscal/report/x/${id}`);
  }

  collect(payload: FiscalCollectDto) {
    return this.http.post<any>(`${environment.BACKEND}/fiscal/collect`, payload);
  }

  addMoney(payload: FiscalAddMoneyDto) {
    return this.http.post(`${environment.BACKEND}/fiscal/add_money`, payload);
  }

  fiscalCheck(payload: {
    sum: number;
    comment_up?: string;
    comment_down?: string;
    products: ProductInDoc[];
    typeMoney: MoneyTypeEnum;
  }) {
    return this.http.post<any>(`${environment.BACKEND}/tax/fiscal_check`, payload);
  }

  // async fiscalReturn() {
  //   const body = {
  //     token: this.localToken,
  //     ver: 6,
  //     source: 'ERP1',
  //     device: this.deviceName,
  //     tag: '',
  //     dt: '20201007192129555',
  //     type: 1,
  //     fiscal: {
  //       fisid: '',
  //       task: 2,
  //       receipt: {
  //         sum: 4687932.99,
  //         round: 0,
  //         rows: [
  //           {
  //             code: '4242',
  //             code1: '79545322',
  //             code2: '45632',
  //             name: 'Пепси 0.5~',
  //             cnt: 21.54,
  //             price: 100312.37,
  //             disc: 0.0,
  //             cost: 2160728.45,
  //             taxgrp: '1'
  //           }
  //         ],
  //         pays: [
  //           {
  //             type: 0,
  //             sum: 4687932.99
  //           }
  //         ]
  //       }
  //     }
  //   };
  //   return this.http.post(this.mainBridge, body);
  // }
}
